import React, {useEffect, useState} from "react";
import {Swiper, SwiperSlide} from "swiper/react";
import ProductsWithSlide from "../ProductsWithSlide";
import {useSelector} from "react-redux";
import lang from "../../lang/lang";
import styles from "./style.module.css";

export default function RelatedProducts() {
    const [activeCategory, setActiveCategory] = useState();
    const {relatedProducts, currentLanguage} = useSelector(({main}) => main);

    useEffect(() => {
        setActiveCategory(relatedProducts?.related_categories?.[0]?.id);
    }, [relatedProducts]);

    return (
        <div className="wrapper">
            <h3 className={styles.title}>
                {lang[currentLanguage].similar_products}
            </h3>
            {relatedProducts?.length > 0 ? (
                <ProductsWithSlide
                    productsData={relatedProducts}
                />
            ) : null
            }
        </div>
    );
}
